export default {"src":"/_next/static/media/card-content.5ee1e644.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};